"use client";

import { Link } from "@/components";
import Image from "next/image";
import type { TResourceCard } from "@/components/common/ResourceCard/resource-card.types";

export default function ResourceCard({
	icon,
	text,
	title,
	link,
}: TResourceCard) {
	return (
		<div className="flex h-full flex-col" data-testid="resource-card">
			<div className={`mb-4 w-[40px] rounded-full p-2 ${icon.colorClass} `}>
				<Image
					src={`/assets/icons/${icon.name}`}
					height={24}
					width={24}
					alt={`icon for ${title}`}
				/>
			</div>
			<h3 className="hmc-subtitle-m pb-1" data-testid="resource-card-title">
				{title}
			</h3>
			<p className="hmc-body-s md:grow">{text}</p>
			<p className="mt-1 md:mt-5">
				<Link
					href={link.url}
					className="c-system-primary hmc-link-s"
					data-testid="resource-card-link"
				>
					{link.title}
				</Link>
			</p>
		</div>
	);
}
